module.exports = __webpack_public_path__ + "static/media/diamond.125ac756.svg";